import { xCircleIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Cancel = createIcon({
  displayName: 'Cancel',
  paths: [
    'M270.641 270.641c133.299-133.299 349.421-133.299 482.72 0 133.295 133.299 133.295 349.421 0 482.72-133.299 133.295-349.421 133.295-482.72 0-133.299-133.299-133.299-349.421 0-482.72zM303.345 363.684c-71.246 99.974-62.057 239.644 27.636 329.333 89.691 89.694 229.331 98.85 329.307 27.61l-356.943-356.943zM720.627 660.288c71.241-99.977 62.084-239.616-27.61-329.307-89.69-89.693-229.359-98.882-329.333-27.636l356.943 356.943z'
  ],
  canvasPaths: canvasIconPaths(xCircleIcon)
})
